/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-unescaped-entities */
import MDBox from "~/components/MDBox";

import PublicFooter from "~/pages/public/PublicFooter";

const PrivacyPolicy = (props) => {
  return (
    <MDBox m={4}>
      <div className="content-wrapper">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light primary-nav container justify-content-start align-items-center">
            {/* <a href="https://www.teamcomputers.com" target="_blank" className="navbar-brand inner"><img
          src="../assets/images/tcpl-logo.png" alt="tcpl-logo"></a>
      <a href="/" className="brand-logo diims-logo inner"><img src="../assets/images/diims-logo-white.png"
          alt="diims-logo"></a> */}
          </nav>
        </header>
        <div classNameName="content mt-5 pt-5 pb-5 container">
          <h2 className="text-center">Privacy Policy</h2>

          <p>
            <strong>Overview:</strong>
          </p>
          <p>
            We give paramount importance to the protection of our users’ privacy
            and security. For this reason, we have adopted the following policy
            to advise you of your choices regarding the use of your personal
            information online. Team Computers Private Limited (“TCPL”) provides
            this Privacy Notice to help you make an informed decision about
            whether to use or continue using our Application, Digital Workspace
            (PlantWatch Pro) Engineer App (hereinafter “App”) and/or any
            services provided by App. This Privacy Policy (“Privacy Policy”)
            explains our policies and procedures regarding the collection, use
            and disclosure of personally identifiable information that we may
            receive from you and other users of the services, through our
            software, applications and our App. Such service, the software,
            mobile applications and the App are collectively referred to in this
            Privacy Policy as the “Service”. This Privacy Policy is subject to
            the App’s terms of use. If you do not agree to this Privacy Policy,
            please do not use the App.
          </p>
          <p>
            <strong>Scope of Policy:</strong>
          </p>
          <p>
            This Policy applies to PlantWatch Pro Engineer App on Google
            Playstore and to web application of PlantWatch Pro. It does not
            apply to any other companies' or organizations' web sites to which
            we link. You should carefully review the privacy policies of those
            web sites in order to determine how they treat your personal
            information.
          </p>
          <p>
            <strong>General Information:</strong>
          </p>
          <p>
            We gather certain types of information about our users and we want
            you to know and understand conditions pertaining to the collection
            of such information. Accessing the App, using the “
            <strong>services</strong>” or downloading materials from here would
            mean that you accept all the conditions and terms set for the users.
            TCPL has the power to amend the terms pertaining to Privacy Policy
            without prior notice. It will be your duty to review this Privacy
            Policy for any changes.
          </p>
          <p>
            <strong>What Information do we collect?</strong>
          </p>
          <ul>
            <li>
              <strong>Non-Personally Identifiable Information:</strong>App
              collects non-personally identifying information that your
              broPlantWatch Proer makes available whenever you visit a App. This
              information includes your Internet connection and hardware specs,
              broPlantWatch Proer type, broPlantWatch Proer language, the date
              and time of your query and one or more cookies that may uniquely
              identify your broPlantWatch Proer.
            </li>
          </ul>
          <ul>
            <li>
              <strong>Personally Identifiable Information:</strong>Based on your
              consent, we collect information you provide when you create an
              account or register with us, enrol for a service, use a service,
              submit a employment application, subscribe to our mailing lists,
              send us an e mail or call us. This information may include:
            </li>
            <li>Your name</li>
            <li>Your mailing address</li>
            <li>Your billing address</li>
            <li>Your e-mail address</li>
            <li>Your phone number</li>
            <li>SMS, call related data</li>
            <li>
              Your credit/debit card number (if you choose it as a mode of
              payment)
            </li>
            <li>Your Facebook Connect sign-in information</li>
            <li>Your history of communication with App</li>
            <li>Your history of payments</li>
            <li>Your IP address</li>
            <li>Your system information and your activities on the App</li>
            <li>Your authentication information</li>
          </ul>
          <ul>
            <li>
              <strong>Information Collection:</strong>To facilitate your use of
              the Service, App may automatically collect certain types of
              information when you access or use the Service, complete surveys,
              send and receive communications, perform search queries and
              marketing activities. In order to collect this data, App may
              utilize automated Apps and files such as cookies and web beacons.
              These automated Apps and files may reside on our servers or on
              your computer or device. If you restrict our ability to use
              automated Apps and files, your ability to access and use all or
              part of the Service may be limited or disabled completely.
            </li>
          </ul>
          <ul>
            <li>
              <strong>Device Data:</strong> Our servers automatically collect
              information when you access or use our Service and record it in
              log files which may include your Internet Protocol (IP) address,
              device type and settings, hardware MAC address, device ID number,
              the address of the web page visited before using the Service,
              error logs, broPlantWatch Proer type and settings, the date and
              time the Services were used, information about broPlantWatch Proer
              configuration and plugins, and language preferences.
              <br />
            </li>
            <li>
              <strong>Location Data: </strong>We receive information from you
              that helps us approximate your location. We may, for example, use
              a business address submitted by your employer, or an IP address
              received from your broPlantWatch Proer or device to determine
              approximate location. We may also collect location information
              from devices in accordance with the consent process provided by
              your device.
            </li>
          </ul>
          <p>
            Additionally and only upon your grant of respective permissions we
            may collect information from third party service providers.
          </p>
          <p>
            <strong>What do we use your information for? </strong>
          </p>
          <p>
            Any of the information we collect from you may be used in one of the
            following ways:
          </p>
          <ul>
            <li>
              <em>To personalize your experience</em>: Your information helps us
              to better respond to your individual needs.
            </li>
            <li>
              <em>To improve our App</em>: We continually strive to improve our
              App offerings and develop new Service offerings based on the
              information and feedback we receive from you.
            </li>
            <li>
              <em>To monitor and analyse use of the Service</em>: This is done
              to ensure smooth running of the Service’s technical administration
              and to increase the Service’s functionality and user-friendliness.
            </li>
            <li>
              <em>To improve customer service</em>: Your information helps us to
              more effectively respond to your customer service requests and
              support needs.
            </li>
            <li>
              <em>To process transactions</em>: Only upon receiving your
              consent, you credit/debit card information will be used via a
              secured payment gateway, for the express purpose of delivering the
              purchased product or service requested.
            </li>
            <li>
              <em>To send periodic emails</em>: The email address you provide
              for order processing, may be used to send you information and
              updates pertaining to your order, in addition to receiving
              occasional App nePlantWatch Pro, updates, related product or
              service information, etc.
            </li>
            <li>
              <em>To be able to tailor the Services</em> to one’s specific needs
              if feasible, for convenience of users and communication with them,
              and as may be required by law.
            </li>
          </ul>
          <p>
            <strong />
            <strong>How do we protect your information? </strong>
          </p>
          <p>
            We implement a variety of security measures to maintain the safety
            of your personal information when you enter, submit, or access your
            personal information.
          </p>
          <p>
            We offer the use of a secure server. All supplied sensitive/credit
            information is transmitted via Secure Socket Layer (SSL) technology
            and then encrypted into our Payment gateway providers database only
            to be accessible by those authorized with special access rights to
            such systems, and are required to keep the information confidential.
          </p>
          <p>
            After a transaction, your private information (credit cards, social
            security numbers, financials, etc.) will not be stored on our
            servers.
          </p>
          <p>
            While we carefully select the Apps we link to, we are not at fault
            for the privacy practices or content of these Apps. You are under
            the privacy policy of the operator of that site when you give
            personal information to them, not App’s privacy policy. Please read
            the policy of that site before sharing any information.
          </p>
          <p>
            <strong>When does App disclose Information?</strong>
          </p>
          <p>
            App reserves the right to disclose personally identifiable
            information and/or non-personally-identifiable information that App
            believes, in good faith, is appropriate or necessary to enforce its
            Terms of Use, take precautions against liability, to investigate and
            defend itself against any third-party claims or allegations, to
            assist government enforcement agencies, to protect the security or
            integrity of our web site, and to protect the rights, property, or
            personal safety of App, our Users or others.
          </p>
          <p>
            <strong>Do we use cookies? </strong>
          </p>
          <p>
            Yes. Cookies are small files that a site or its service provider
            transfers to your computer’s hard drive through your Web
            broPlantWatch Proer (if you allow) that enables the sites or service
            providers systems to recognize your broPlantWatch Proer and capture
            and remember certain information.
          </p>
          <p>
            We use cookies to enhance and personalize your experience of the
            Service of App’s web sites, including to operate and improve
            offerings through the Service and/or web sites; to help authenticate
            your identity when you visit and transact with the Service, and/or
            web sites; to understand and save your preferences and registration
            information for future visits and compile aggregate data about site
            traffic and site interaction so that we can offer better site
            experiences and Apps in the future. We may contract with third-party
            service providers to assist us in better understanding our site
            visitors. These service providers are not permitted to use the
            information collected on our behalf except to help us conduct and
            improve our business.
          </p>
          <p>
            <strong>Do we disclose any information to outside parties? </strong>
          </p>
          <p>
            We do not sell, trade, or otherwise transfer to outside parties your
            personally identifiable information. This does not include trusted
            third parties who assist us in operating our App, conducting our
            business, or servicing you, so long as those parties agree to keep
            this information confidential. App reserves the right to disclose
            personally identifiable information and/or
            non-personally-identifiable information that App believes, in good
            faith, is appropriate or necessary to enforce its Terms of Use, take
            precautions against liability, to investigate and defend itself
            against any third-party claims or allegations, to assist government
            enforcement agencies, to protect the security or integrity of our
            web site, and to protect the rights, property, or personal safety of
            App, our Users or others. We may use and disclose to third parties,
            information we collect in aggregated, non-personally identifiable
            form for research and informational purposes and to help us make
            sales, marketing and business decisions for marketing, advertising,
            or other uses. We do not sell your personal information.
          </p>
          <p>
            <strong>CHANGE OF CONTROL:</strong>
          </p>
          <p>
            In the event of the change of control of App or a business
            transition, such as, reorganization, merger, acquisition, or sale of
            assets, your information may be transferred to the successor
            organization. You will be notified via a message to the email
            address associated with your account of any such deal and your
            information would remain subject to the commitments contained in
            this Privacy Policy until such time as this Privacy Policy is
            updated or amended by the acquiring party upon notice to you.
          </p>
          <p>
            <strong>INFORMATION STORAGE</strong>
          </p>
          <p>
            <strong>Permission to Use Information:</strong>&nbsp;By submitting
            your personal information, you agree to its transfer, storage or
            processing. We will take all steps reasonably necessary to ensure
            that your data is treated securely and in accordance with this
            Privacy Policy.
          </p>
          <p>
            <strong>Data Retention: </strong>We only retain your personal data
            for as long as your account is active or otherwise for a limited
            period of time as long as we need to fulfil the purposes for which
            we had initially collected it, unless otherwise required by law. We
            will retain and use information as necessary to comply with our
            legal obligations, resolve disputes and enforce our agreement as
            required by the applicable law.
          </p>
          <p>
            <strong>Password:</strong>&nbsp;Where we have given you (or where
            you have chosen) a password which enables you to access certain
            Services or specific areas of the App, you are responsible for
            keeping this password confidential. We ask that you do not share
            your password with anyone.
          </p>
          <p>
            <strong>Disclaimer:</strong>&nbsp;Unfortunately, the transmission of
            information via the Internet is not completely secure. Although we
            will do our best to protect your personal data, we cannot guarantee
            the security of your data transmitted to us via the Internet; any
            such transmission is at your own risk.
          </p>
          <p>
            <strong>NO ERROR-FREE PERFORMANCE</strong>
          </p>
          <p>
            App does not guarantee error-free performance under this Privacy
            Policy. We may not always catch an unintended privacy issue, despite
            our reasonable efforts to do so. Accordingly, we welcome your
            feedback regarding any privacy concerns that you may have, including
            how we can improve this Privacy Policy. We will use reasonable
            efforts to comply with this Privacy Policy and will take prompt
            corrective action when we learn of any failure to comply with it.
          </p>
          <p>
            <strong>
              Modification and Deletion of Personally Identifiable Information
            </strong>
          </p>

          <p>
            <strong>Deletion:</strong> In order to delete the personally
            identifiable information you submitted, you can notify us that you
            wish to delete your personally identifiable information or any part
            thereof contained at our databases.
          </p>
          <p>
            <strong>Modification:</strong> If you wish to modify or update your
            personally identifiable information, use the App or application
            interface.
          </p>
          <p>
            Please note that deletion of your personally identifiable
            information from App’s database will not prevent App from using
            gathered anonymous information.
          </p>
          <p>
            <strong>Third party links: </strong>
          </p>
          <p>
            Occasionally, at our discretion, we may include or offer third party
            products or services on our App. These third party sites have
            separate and independent privacy policies. We therefore have no
            responsibility or liability for the content and activities of these
            linked sites. Nonetheless, we seek to protect the integrity of our
            site and welcome any feedback about these sites.
          </p>
          <p>
            <strong>Minors’ Online Privacy Protection:</strong>
          </p>
          <p>
            App's Service and App are intended for a general audience and
            individuals under the age of eighteen (18) are not permitted to
            register with App’s Services.
          </p>
          <p>
            <strong>Online Privacy Policy Only: </strong>
          </p>
          <p>
            This online privacy policy applies only to information collected
            through our App and not to information collected offline.
          </p>
          <p>
            <strong>Terms and Conditions: </strong>
          </p>
          <p>
            Please also visit our Terms and Conditions section establishing the
            use, disclaimers, and limitations of liability governing the use of
            our App at
            <a classNameName="termAndCondition" href="">
              Terms &amp; Condition
            </a>
            .
          </p>
          <p>
            <strong>Your Consent: </strong>
          </p>
          <p>
            By using our site, you consent to our App’s privacy policy. You have
            the right to withdraw that consent at any time. However, this will
            not affect the lawfulness of processing based on your prior consent.
          </p>
          <p>
            <strong>Changes to our Privacy Policy: </strong>
          </p>
          <p>
            If we decide to change our privacy policy, we will send an email
            notifying you of any changes.
          </p>
          <p>
            <strong>Your Rights: </strong>Depending on the applicable law you
            may have the following rights in relation to your personal data:
          </p>
          <ul>
            <li>Right to access your personal data being processed by us.</li>
            <li>
              Right to rectify any discrepancy, inaccuracy in your personal data
              or complete any incomplete details.
            </li>
            <li>
              Right to delete or remove your personal data in certain
              circumstances
            </li>
            <li>
              Right to restrict or object to processing of your personal data in
              certain circumstances, such as where the accuracy of personal data
              is disputed.
            </li>
            <li>Right to withdraw your consent.</li>
          </ul>

          <p>
            You exercise of any right will not affect the lawfulness of
            processing based on your prior consent.
          </p>
          <p>
            If you have a concern about any aspect of our privacy practices,
            including the way we have handled your Personal Data, you can report
            it to the data protection authority that is authorized to hear those
            concerns.
          </p>
          <p>
            You may exercise your rights by contacting us as folloPlantWatch
            Pro:
            <em>
              <a>imsnextapp@teamcomputers.com</a>
            </em>
          </p>

          <p>
            <strong>Be Vigilant and Circumspect: </strong>
          </p>
          <p>
            Even the best policy can't protect your online privacy and security
            in all circumstances. Unscrupulous advertisers, hackers, and scam
            artists are constantly searching the Internet looking for new
            targets. Your best protection is to understand the limits to privacy
            on the Internet and use common sense in all of your on-line
            activities.
          </p>
          <p>
            Be aware that e-mail is an inherently insecure form of
            communication. Remember that third parties are sometimes able to
            illegally intercept your unencrypted messages. Anytime you access a
            service or post a message to an on-line bulletin board, your e-mail
            address can be accessed by advertisers looking to compile lists for
            unsolicited commercial e-mail (also known as spam). Be sure that you
            only disclose your e-mail address in circumstances in which it is
            safe to do so.
          </p>
          <p>
            Be aware that e-mail is an inherently insecure form of
            communication. Remember that third parties are sometimes able to
            illegally intercept your unencrypted messages. Anytime you access a
            service or post a message to an on-line bulletin board, your e-mail
            address can be accessed by advertisers looking to compile lists for
            unsolicited commercial e-mail (also known as spam). Be sure that you
            only disclose your e-mail address in circumstances in which it is
            safe to do so.
          </p>
          <p>
            Beware of scams in which persons unknown to you request your screen
            name, password, or credit card information. Make sure you verify the
            identity of anyone asking for personal information. Always monitor
            your children's on-line activities and educate them as to the rules
            for safe Internet use. As always, if you have any questions, please
            feel free to contact us with further questions.
          </p>

          <p>
            If you still have questions or concerns about our privacy policy,
            please write us at:
          </p>
          <p>
            <strong>Team Computers Pvt. Ltd.</strong>
          </p>
          <p>
            <strong>No.1, Mohammadpur, Bhikaji Cama Place</strong>
          </p>
          <p style={{ paddingBottom: "4rem" }}>
            <strong>New Delhi – 110066, India.</strong>
          </p>
        </div>
      </div>
      <PublicFooter />
    </MDBox>
  );
};

export default PrivacyPolicy;
